import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import { GET_COMPAIGN_DETAILS, GET_COMPAIGN_DETAILS_SUCCESS, GET_COMPAIGN_DETAILS_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* getCompaignDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { compaignId } = payload?.urlParams || {};

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-campaigns/${compaignId}`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_COMPAIGN_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_COMPAIGN_DETAILS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_COMPAIGN_DETAILS_ERROR, payload: error });
  }
}

export function* watchgetCompaignDetails() {
  yield takeEvery(GET_COMPAIGN_DETAILS, getCompaignDetails);
}

function* getCompaignDetailsSaga() {
  yield all([fork(watchgetCompaignDetails)]);
}

export default getCompaignDetailsSaga;
